import { useEffect, useState } from 'react';
import './App.css';
import { Route, Routes, useNavigate } from 'react-router-dom';
import Calling from './api/Calling';
import { ToastContainer } from 'react-toastify';
import Navbar1 from './components/Navbar/Navbar1';
import Navbar2 from './components/Navbar/Navbar2';
import Login from './admin/Login/Login';
import Page404 from './components/page/Page404';
import Logout from './admin/Login/Logout';
import Error from './admin/Login/Error';
import Home from './admin/Home';
import NewPw from './admin/Login/NewPw';
import ForgetPw from './admin/Login/ForgetPw';
import ForgetPwOtp from './admin/Login/ForgetPwOtp';
import LoginOtp from './admin/Login/LoginOtp';
import Profile from './admin/Profile/Profile';
import ApiConfig from './admin/mobile/ApiConfig';
import Mobile from './admin/mobile/Mobile';
import MobileAdd from './admin/mobile/MobileAdd';
import INSPACTLOCK from './components/INSPACTLOCK';
import IpManager from './admin/mobile/IpManager';

function App() {
  const [isAuthorized, setIsAuthorized] = useState(null); // Initially null
  const navigate = useNavigate();

  const handleLoginStatusChange = (status) => {
    if (status) {
      setIsAuthorized(true);
    }
  };

  const handleLogout = () => {
    setIsAuthorized(false);
    localStorage.removeItem('admin_number_store');
    navigate('/admin/panel/login');
  };

  useEffect(() => {
    const checkAuthorization = async () => {
      try {
        const adminToken = localStorage.getItem('admin_number_store');

        if (!adminToken) {
          setIsAuthorized(false);
          return;
        }

        const resp = await Calling.AdminAuthCheck();
        setIsAuthorized(resp.status);
      } catch (error) {
        console.log(error);
        setIsAuthorized(false);
      }
    };

    checkAuthorization();
  }, []);

  return (
    <div className="flex roboto-regular bg-main-bg">
      <ToastContainer />
      <INSPACTLOCK/>
      {isAuthorized && <Navbar1 />}
      <div className="flex ml-w-15 w-[100%]">
        {isAuthorized && <Navbar2 />}
        <Routes>
          {isAuthorized ? (
            <>
              <Route path="/" element={<Home />} />
              <Route path="/Logout" element={<Logout onLogout={handleLogout} />} />
              <Route path='/profile' element={<Profile />} />

              {/* Mobile */}
              <Route path='/manage/mobile/' element={<Mobile />} />
              <Route path='/manage/mobile/add' element={<MobileAdd />} />

              {/* IP Manager */}
              <Route path='/manage/ip-manager' element={<IpManager />} />




              <Route path='/manage/mobile/api-config' element={<ApiConfig />} />

              <Route path="*" element={<Error />} />
            </>
          ) : (
            <>
              <Route path='/admin/panel/login' element={<Login />} />
              <Route path='/admin/panel/login/otp' element={<LoginOtp onLogin={handleLoginStatusChange} />} />
              <Route path='/admin/panel/forgetpw' element={<ForgetPw />} />
              <Route path='/admin/panel/forget/otp' element={<ForgetPwOtp />} />
              <Route path='/admin/panel/new/password' element={<NewPw />} />
              {/* <Route path='/web/delete/user' element={<DeleteUserPage />} /> */}
              <Route path='*' element={<Page404 />} />
            </>
          )}
        </Routes>
      </div>
    </div>
  );
}

export default App;
